import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { pickHeroVideo, type HeroVideo } from "@/lib/heroVideo";

/** The home page video, or null when the frame is switched off. */
export function useHeroVideo() {
  return useQuery({
    queryKey: ["hero-video-public"],
    queryFn: async (): Promise<HeroVideo | null> => {
      const [settings, videos] = await Promise.all([
        supabase.from("hero_video_settings").select("enabled").eq("id", 1).maybeSingle(),
        supabase.from("hero_videos").select("*").eq("active", true),
      ]);
      if (settings.error || videos.error) return null;
      return pickHeroVideo(!!settings.data?.enabled, (videos.data ?? []) as HeroVideo[]);
    },
    staleTime: 60_000,
  });
}
